// extracted by mini-css-extract-plugin
export default {"sharebtn":"Share_sharebtn__Ye8CP"};